<div class="container">
    <div class="row">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card marginBottom2Rem">
                <mat-card-header class="headerWithAccentButton">
                    <mat-card-title>Weitere Angaben von {{this.currentEvent?.title}}</mat-card-title>

                </mat-card-header>

                <mat-card-content [formGroup]="addForm">
                    <h4 class="marginBottom2Rem"> Alternatives Bild:</h4>
                    <div class="row marginBottom2Rem" *ngIf=" this.changeImage">
                        <div class="col-sm-12">
                            <div ngx-dropzone [accept]="'image/jpeg,image/jpg,image/png'" (change)="onSelect($event)"
                                [multiple]="false">
                                <ngx-dropzone-label>
                                    <div>
                                        <h3>Bild hierher ziehen</h3>
                                        <h5>ODER</h5>
                                        <button mat-raised-button color="accent">Durchsuchen</button>
                                    </div>
                                </ngx-dropzone-label>
                                <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files"
                                    [file]="f" [removable]="true" (removed)="onRemove(f)">
                                </ngx-dropzone-image-preview>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <div class="centerVerticalAndHoritontal ">
                                <img class="img-responsive  img-clickable"
                                    src="{{this.addForm.value?.alternativeImage?.url}}" alt="">
                            </div>
                            <div *ngFor="let p of imageProperties"
                                class="centerVerticalAndHoritontal marginTop2Rem marginBottom2Rem">
                                <button mat-raised-button color="accent"
                                    (click)="openImageGallery(p,'alternative')">Bild
                                    auswählen</button>
                                <button mat-raised-button color="primary" (click)="toogleImageUpload()"
                                    class="margrinLeftBtn">Bild
                                    hochladen</button>
                            </div>
                        </div>
                    </div>



                    <h4 class="marginTop2Rem"> Kurzbeschreibung</h4>

                    <ckeditor [editor]="Editor" [config]="config"
                        style="display:inline-block;width: 100%;min-height: 250px;height: 350px;"
                        formControlName="shortDescription"></ckeditor>



                    <h4 class="marginTop2Rem"> Erweiterte Beschreibung 1</h4>
                    <ckeditor [editor]="Editor" [config]="config"
                        style="display:inline-block;width: 100%;min-height: 250px;height: 350px;"
                        formControlName="advancedDescription1"></ckeditor>

                    <h4 class="marginTop2Rem"> Erweiterte Beschreibung 2</h4>
                    <ckeditor [editor]="Editor" [config]="config"
                        style="display:inline-block;width: 100%;min-height: 250px;height: 350px;"
                        formControlName="advancedDescription2"></ckeditor>

                    <h4 class="marginTop2Rem"> Tertiäres Bild:</h4>
                    <div class="row marginBottom2Rem" *ngIf="changeImageTertiaryImage">
                        <div class="col-sm-12">
                            <div ngx-dropzone [accept]="'image/jpeg,image/jpg,image/png'"
                                (change)="onSelectTertiaryImage($event)" [multiple]="false">
                                <ngx-dropzone-label>
                                    <div>
                                        <h3>Bild hierher ziehen</h3>
                                        <h5>ODER</h5>
                                        <button mat-raised-button color="accent">Durchsuchen</button>
                                    </div>
                                </ngx-dropzone-label>
                                <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview"
                                    *ngFor="let f of filesTertiaryImage" [file]="f" [removable]="true"
                                    (removed)="onRemoveTertiaryImage(f)">
                                </ngx-dropzone-image-preview>
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-sm-12">
                            <div class="centerVerticalAndHoritontal ">
                                <img class="img-responsive  img-clickable"
                                    src="{{this.addForm.value?.tertiaryImage?.url}}" alt="">
                            </div>
                            <div *ngFor="let p of imageProperties"
                                class="centerVerticalAndHoritontal marginTop2Rem marginBottom2Rem">
                                <button mat-raised-button color="accent"
                                    (click)="openImageGallery(p,'tertiaryImage')">Bild
                                    auswählen</button>
                                <button mat-raised-button color="primary" (click)="toogleImageUploadTertiaryImag()"
                                    class="margrinLeftBtn">Bild
                                    hochladen</button>
                            </div>
                        </div>
                    </div>
                    <h4 class="marginTop2Rem"> Erweiterter Reservierungshinweis</h4>
                    <ckeditor [editor]="Editor" [config]="config"
                        style="display:inline-block;width: 100%;min-height: 250px;height: 350px;"
                        formControlName="advancedReservationClue"></ckeditor>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="movebacktoOverview()"> Abbrechen</button>
                    <button mat-button color="primary" (click)="saveAdvancedDetails()">Änderungen Speichern</button>
                </mat-card-actions>
            </mat-card>

        </div>
    </div>
</div>